<mat-slide-toggle
  class="bd-toggle min-w-[132px] my-8"
  blazeClickable
  disableRipple
  labelPosition="after"
  [checked]="rule().enabled"
  (toggleChange)="onRuleEnabledChange(rule().day)"
>
  {{ rule().day }}
</mat-slide-toggle>

@if (rule().enabled) {
  <div class="flex items-center gap-x-24 gap-y-8 flex-wrap">
    @for (
      slot of rule().timeSlots;
      track $index;
      let slotIndex = $index;
      let isFirstSlot = $first
    ) {
      <div class="flex items-center gap-8">
        <div class="flex items-center gap-8">
          <blaze-times-range-picker
            [value]="slot"
            [error]="errors()?.[slotIndex]"
            (valueChanged)="onSlotTimeChange($event, rule().day, slotIndex)"
          />
          @if (!isFirstSlot) {
            <button
              class="button flex rounded p-8 !text-bat-title !w-40 !min-h-[40px]"
              blazeClickable
              blazeIconButton
              (click)="onDeleteSlot(rule().day, slotIndex)"
            >
              <mat-icon svgIcon="icon_trash_16" />
            </button>
          }
        </div>
      </div>
    }
    <div class="flex gap-8 items-center">
      <button
        class="button flex rounded p-8 !text-bat-title !w-40 !min-h-[40px]"
        blazeClickable
        blazeIconButton
        (click)="onAddSlot(rule().day)"
      >
        <mat-icon svgIcon="icon_add_16" />
      </button>
      @let hasErrors = !!errors()?.length;
      <button
        class="button flex rounded p-8 !text-bat-title !w-40 !min-h-[40px]"
        [class.opacity-50]="hasErrors"
        [disabled]="hasErrors"
        blazeClickable
        blazeIconButton
        [matMenuTriggerFor]="dayPickerMenu"
      >
        <mat-icon svgIcon="icon_copy_to_clipboard_16" />
      </button>
    </div>
  </div>
}

<mat-menu #dayPickerMenu="matMenu" class="bd-menu" xPosition="before" yPosition="below">
  @for (day of visibleDays(); track $index) {
    <button mat-menu-item [disabled]="day === rule().day" (click)="copySlots.emit(day)">
      <span class="text">{{ day }}</span>
    </button>
  }
</mat-menu>
